"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CreateDismissedNotificationResponse () {
        return CreateDismissedNotificationResponse;
    },
    get GetDismissedNotificationResponse () {
        return GetDismissedNotificationResponse;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const GetDismissedNotificationResponse = _zod.z.object({
    isDismissed: _zod.z.boolean(),
    dismissedNotificationCount: _zod.z.number(),
    notificationId: _utilsisomorphic.transformObjectId,
    userId: _utilsisomorphic.transformObjectId
});
const CreateDismissedNotificationResponse = _zod.z.object({
    acknowledged: _zod.z.boolean(),
    insertedId: _utilsisomorphic.transformObjectId
});
